/* Arbove — Vidéo média (grand format) : lazy-load + play/pause via IntersectionObserver.
   Cible tout conteneur [data-arv-lazy] contenant un <video>.
   - preload="none" : la vidéo n'est téléchargée qu'à l'entrée dans le viewport.
   - Pause dès la sortie du viewport.
   - prefers-reduced-motion : on ne charge/joue rien (le CSS affiche l'image fixe). */
(function () {
  if (window.__arMediaVideo) return;
  window.__arMediaVideo = true;

  var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  function play(v) {
    if (!v.dataset.arvLoaded) {
      try { v.load(); } catch (e) {}
      v.dataset.arvLoaded = '1';
    }
    var p = v.play();
    if (p && p.catch) p.catch(function () {});
  }

  function init() {
    var els = document.querySelectorAll('[data-arv-lazy]');
    if (!els.length || reduce) return;

    if (!('IntersectionObserver' in window)) {
      for (var i = 0; i < els.length; i++) {
        var v = els[i].querySelector('video');
        if (v) play(v);
      }
      return;
    }

    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        var video = entry.target.querySelector('video');
        if (!video) return;
        if (entry.isIntersecting) play(video);
        else if (!video.paused) video.pause();
      });
    }, { threshold: 0.25, rootMargin: '0px 0px -10% 0px' });

    for (var k = 0; k < els.length; k++) {
      if (els[k].querySelector('video')) io.observe(els[k]);
    }
  }

  if (document.readyState !== 'loading') init();
  else document.addEventListener('DOMContentLoaded', init);
})();
